import { Component, ElementRef, OnInit, Output, EventEmitter, ViewChild } from '@angular/core';
import { GlobalConstants } from '../../../common/constants/global.constant';
import { SkuIdInfoService } from '../../../../app/core/routing/services/sku-ids/sku-id-info.service';
import { first } from 'rxjs/internal/operators/first';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';
import { Subject } from 'rxjs/internal/Subject';
import { SkuIdInfo } from '../../../../app/core/routing/services/sku-ids/sku-id-info.i';
import { User } from '../../account/login/_models/user.model';
import { AppGlobal } from '../../../../../src/app/core/state/app-global';
import { DataService } from '../../../../../src/app/core/data/data-service';
import { CommonService } from '../../../common/services/common.service';
import { Enumvalues, OemConstants } from '../../../core/routing/services/oem/constants/oem.constants';
import { StoresConstant } from '../../../core/routing/services/stores_api/constants/stores.constant';
import { ActiveUserConstants } from '../../../core/routing/services/activeusers_api/constatnts/activeusers.constant';
import { AssetLibraryConstants } from '../../../core/routing/services/asset-library/constants/asset-library.constant';
import { CreateProfileService } from '../../../core/routing/services/profile/create-profile.service';

@Component({
  selector: 'iposcen-sku-id-info',
  templateUrl: './sku-id-info.component.html',
  styleUrls: ['./sku-id-info.component.scss']
})
export class SkuIdInfoComponent implements OnInit {
  @ViewChild('deleteModal') deleteModal: ElementRef;
  @ViewChild('deleteModalSkus') deleteModalSkus: ElementRef
  @ViewChild('deleteAckModal') deleteAckModal: ElementRef;
  @ViewChild('deleteAckModalSkus') deleteAckModalSkus: ElementRef;
  @ViewChild('searchValue') animateThis: ElementRef;
  @Output() readonly skuIdLength = new EventEmitter<any>();
  isSKUListEmpty: boolean;
  tabIndex = 0;
  tabbIndex= [];
  sortValue = GlobalConstants.CREATED_DATE;
  createdDateVal = GlobalConstants.CREATED_DATE;
  skuCodeVal = GlobalConstants.SKU_CODE;
  allSkuList: SkuIdInfo[];
  displayskuGroups = [];
  noOfskusSelected = [];
  tooltipEdit = GlobalConstants.EDIT;
  tooltipDelete = GlobalConstants.DELETE;
  internalName = GlobalConstants.INTERNAL_NAME;
  batteryLifeText = GlobalConstants.BATTERY_LIFE;
  userId = sessionStorage.getItem(GlobalConstants.USER_ID);
  retailerId: string = sessionStorage.getItem(GlobalConstants.RETAILER_ID);
  page = 1;
  pageSize = 5;
  maxSize = 5;
  isCustomTileEnabled = false;
  isPriceSuppressionEnabled = false;
  userRole: string;
  retailerConfig: any;
  segmentsList = [];
  customTileList = [];
  PromosList = [];
  skuIDToDelete: string;
  skuIDToDeleteName: string;
  skuIDButtonText = GlobalConstants.SKUID_DELETE_BTN_TEXT;
  skuIDsButtonText = GlobalConstants.SKUIDS_DELETE_BTN_TEXT;
  showRetailGif = false;
  valueForSkuSearch: string;
  valueForSearch: string;
  searchTag: string;
  skuSearchData: string;
  isLoading = false;
  isSearchDataEmpty: boolean = false;
  displayEditSkuGroups: SkuIdInfo[];
  globConst = GlobalConstants;
  searchClose: boolean;
  searchPlaceholder = GlobalConstants.SEARCHPLACEHOLDER;
  loadFlag: string;
  searchSku = false;
  isSrtUser =  false;
  searchQueue = {};
  searchString: string;
  assetLibraryConst = AssetLibraryConstants;
  expanded: boolean[] = [];
  skuDeleteEnable: boolean = false;
  noSkuSelected: boolean = true;
  skusToDelete=[];
  deleteAckSkusText = GlobalConstants.SKUIDS_ACK_TEXT;
  isArabic = localStorage.getItem('preferredLanguage') === 'ar-sa';
  isHebrew = localStorage.getItem('preferredLanguage') === 'he';
  private ngUnsubscribe = new Subject<boolean>();

  noskusToDelete: number;
  deleteSkuMessage: any;
  deleteSelectedSku: string;
  deleteSelectedSkuText: string;
  isPolish = localStorage.getItem('preferredLanguage') === 'pl';
  constructor(private appGlobal: AppGlobal,
    private createProfileService: CreateProfileService,
    private skuIdService: SkuIdInfoService,
    private cmnService: CommonService,
    private dataService: DataService) { }
  

  ngOnInit(): void {
    this.getAllSkuList();
    this.cmnService.getRetailGifValue
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(data => {
        if (data) {
          this.showRetailGif = true;
        }
      });
    this.appGlobal.$userAccount
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(async (userAccount: User) => {
        this.userRole = userAccount.role;
        if (this.userRole === GlobalConstants.RETAIL_HQ_USER || this.userRole === GlobalConstants.STORE_USER || this.userRole === GlobalConstants.REGIONALHQ) {
          this.retailerConfig = (userAccount.configurations !== undefined) ? JSON.parse(userAccount.configurations) : await this.getRetailerConfig();
          this.isCustomTileEnabled = this.retailerConfig?.customSrtEnabled ? this.retailerConfig?.customSrtEnabled : false;
          this.isPriceSuppressionEnabled = this.retailerConfig?.isPriceSupress ? this.retailerConfig?.isPriceSupress : false;
        }
      });
      if (this.userRole === GlobalConstants.SRT_ADMIN) {
        this.isSrtUser = true;
      }
    this.loadFlag = StoresConstant.LOAD_FLAG;
    this.valueForSkuSearch = GlobalConstants.SKU_CODE;
    this.skusToDelete=[];
  }

  getRetailerConfig() {
    return new Promise((resolve) => {
      this.createProfileService.getUserRoleData(this.userId, this.retailerId)
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe(data => {
          const config = JSON.parse(data?.retailer?.configurations);
          resolve(config);
        })
    })
  }

  sortByDate() {
    this.sortValue = GlobalConstants.CREATED_DATE;
    this.displayskuGroups.sort((sku1, sku2) => sku2.updatedTime - sku1.updatedTime);
  }

  getDetailsOfSkuID(id: string) {
    this.displayskuGroups.forEach(element => {
      if (element.skuID === id) {
        element.isExpanded = !element.isExpanded;
        if ((element.skuList?.segmentID || element.skuList.customHeroTile || element.skuList?.promotionalContentIDs) && element.isExpanded) {
          const displaySKUList = this.displayEditSkuGroups?.filter(ele => ele.skuID === id);
          const filteredSegmentList = this.skuIdService.segmentContentList.filter(
            seg => seg.id === displaySKUList[0]?.skuList['segmentID']);
          element.skuList.segmentID = (filteredSegmentList.length > 0) ? filteredSegmentList[0].name : '';

          const filteredCustomTileList = this.skuIdService.mainTileContentList.filter(
            hero => hero.id === displaySKUList[0]?.skuList['customHeroTile']);
          element.skuList.customHeroTile = (filteredCustomTileList.length > 0) ? filteredCustomTileList[0].name : '';

          const filteredPromos = this.getFilteredPromoContents(displaySKUList[0]?.skuList['promotionalContentIDs']);
          if (filteredPromos.length > 0) {
            element.skuList.promotionalContentIDs[0] = filteredPromos[0]?.name || '';
            element.skuList.promotionalContentIDs[1] = filteredPromos[1]?.name || '';
            element.skuList.promotionalContentIDs[2] = filteredPromos[2]?.name || '';
          } else {
            element.skuList.promotionalContentIDs[0] = element.skuList.promotionalContentIDs[1] = element.skuList.promotionalContentIDs[2] = '';
          }
        }
      }
    });
  }

  getFilteredPromoContents(data) {
    const filteredpromosList = [];
    for (let i = 0; i < data.length; i++) {
      const filteredList = this.skuIdService.promoContentList.filter(p => p.id === data[i]);
      if (filteredList.length > 0) {
        const promoObj = {
          id: filteredList[0].id,
          name: filteredList[0].name
        }
        filteredpromosList[i] = promoObj;
      }
    }
    return filteredpromosList;
  }

  sortByName() {
    this.page = 1;
    this.sortValue = GlobalConstants.SKU_CODE;
    this.displayskuGroups.sort((sku1, sku2) =>
      sku1.publishedName.localeCompare(sku2.publishedName));
  }
  setParentConfig(data) {
    if (!data.cancel) {
      this.getAllSkuList();
    }
    this.tabIndex = 0;
  }

  openDeletePopup(skuId: string) {
    this.skuIDToDelete = this.displayskuGroups.find(ele => ele.skuID === skuId).skuID;
    this.skuIDToDeleteName = this.displayskuGroups.find(ele => ele.skuID === skuId).publishedName;
    this.openModal(this.deleteModal);
  }

  openModal(modal: any) { modal.open(); }
  closeModal(modal: any) { modal.close(); }

  createNewSKU() {
    this.dataService.setSKUIDContent(undefined);
    this.tabIndex = 1;
  }
  // To get List of sku-info
  getAllSkuList(searchString?: string ) {
    this.skuIdService.getAllSkuInfoByUSer(searchString, this.retailerId)
      .pipe(takeUntil(this.ngUnsubscribe))
      .pipe(first())
      .subscribe(getAllSkuList => {
        this.allSkuList = (getAllSkuList.skuContent as SkuIdInfo[]);
        this.displayEditSkuGroups = JSON.parse(JSON.stringify(this.allSkuList));
        this.isSKUListEmpty = (this.allSkuList.length === 0) || false;
        this.skuIdLength.emit(this.allSkuList?.length)
        this.displayskuGroups = [];
        this.allSkuList.forEach(ele => {
          ele.createdByUser = (ele.createdByUser === this.userId) ? GlobalConstants.ME : ele.createdByUser;
          this.displayskuGroups.push(ele);
        });
        this.displayskuGroups.forEach(element => {
          element.isExpanded = false;
          if (element.updatedTime) {
            element.updatedTime = new Date(element.updatedTime);
            element.updatedTimeDisplay = new Date(element.updatedTime).toLocaleString()
              .replace(',', '');
          }
        });
        this.sortByDate();
      },
        error => {
          // do something
        });
  }

  deleteSKUIdContent(skuId: string) {
    console.log(skuId) // 1,3,5,9
    let skusMultiDelete: any = {};
    skusMultiDelete = {skuList: [skuId]}
    this.skuIdService.deleteSKUIdContentByIds(skusMultiDelete)
      .pipe(takeUntil(this.ngUnsubscribe))
      .pipe(first())
      .subscribe(() => {
        const index = this.displayskuGroups.findIndex(d => d.skuID === skuId);
        if (index >= 0) {
          this.displayskuGroups.splice(index, 1);
        }
        this.isSKUListEmpty = (this.displayskuGroups.length === 0) || false;  
        this.closeModal(this.deleteModal);
        this.openModal(this.deleteAckModal);
      },
        error => {
          this.closeModal(this.deleteModal);
          this.closeModal(this.deleteAckModal);
        });
        this.skusToDelete = [];
  }

  editSKUIdContent(skuId: string) {
    const skuIdToEdit = this.displayEditSkuGroups.find(ele => ele.skuID === skuId);
    this.dataService.setSKUIDContent(skuIdToEdit);
    this.tabIndex = 1;
  }
  //For II-3942 STORY
  onSelectChange(value) {
    if (value === Enumvalues.VALUE_1) {
      this.searchTag = OemConstants.SKU_ID_SEARCH;
      this.valueForSkuSearch = GlobalConstants.SKU_CODE;
    } else if (value === Enumvalues.VALUE_2) {
      this.searchTag = OemConstants.INTERNAL_NAME_SEARCH;
      this.valueForSkuSearch = GlobalConstants.INTERNAL_NAME;
    }
  }

  searchSkuOnEnter(skuSearchData) {
    this.searchSku = true;
    this.animateThis.nativeElement.blur();
    this.searchSkuIds(skuSearchData);
  }

  searchSkuIds(skuSearchData) {
    this.searchClose = true;
    if (this.loadFlag === StoresConstant.LOAD_FLAG && !this.searchTag) {
      this.searchTag = OemConstants.SKU_ID_SEARCH;
      this.loadFlag = StoresConstant.UNLOAD_FLAG;
    }
    if (skuSearchData && this.searchTag) {
      this.searchQueue = {};// To clear previous seletion
      this.searchQueue[this.searchTag] = encodeURIComponent(skuSearchData);
      this.getSkuSearchData();
    } else {
      this.getAllSkuList();
      this.page = 1;
    }
  }

  closeExpandedTab() {
    let temp = new Array(this.expanded.length).fill(false);
    this.expanded = [...temp];
  }

  getSkuSearchData() {
    this.searchString = '';
    this.page = 1;
    if (this.searchQueue) {
      for (const [filterKeyName, fliterData] of Object.entries(this.searchQueue)) {
        this.searchString += `?${filterKeyName}=${fliterData}`;
      }
      this.getAllSkuList(this.searchString);
    } else {
      this.getAllSkuList();
    }
    this.closeExpandedTab();
  }

  clearSearch(val: string) {
    if (val?.length === 0 && this.searchClose) {
      this.searchClose = false;
      this.searchQueue = {};
      this.page = 1;
      this.searchSku = false;
      this.getSkuSearchData();
      this.skuSearchData = ActiveUserConstants.EMPTY_VALUE;
    }
  }
  multiDeleteSku() {
    this.noSkuSelected = (this.skusToDelete.length === 0);
    this.skuDeleteEnable  = true;
  }
  // populating skuId's to be deleted as part of multi delete functionality
  checkSkuId(event,id) {
    if (event?.target.checked) {
      this.noSkuSelected = false;
      this.skusToDelete.push(id);
    } else {
      let index = this.skusToDelete.indexOf(id);
      if(index > -1){
        this.skusToDelete.splice(index,1);
      }
    }
    this.noSkuSelected = (this.skusToDelete.length === 0);
    
  }
  resetSkuDelete() {
    this.skuDeleteEnable = false;
    this.skusToDelete = []
  }
  deleteSeletedSku() {
    // open delete model
    this.tabbIndex = this.skusToDelete;
    this.deleteSkuMessage = this.displayskuGroups.find(item => item.skuID === this.tabbIndex[0]).publishedName;
    this.deleteSelectedSku = `Delete ${this.deleteSkuMessage}?`;
    this.deleteSelectedSkuText = `${this.deleteSkuMessage} has been deleted.`;
    this.openModal(this.deleteModalSkus);
  }

  deleteSKUIdsContent(skuIds: any) {
    let skusMultiDelete: any = {};
    skusMultiDelete = {
      skuList: skuIds
    }
    if (skuIds && skuIds.length > 0) {
      this.skuIdService.deleteSKUIdContentByIds(skusMultiDelete)
        .pipe(takeUntil(this.ngUnsubscribe)).pipe(first()).subscribe(() => {
          this.isSKUListEmpty = (this.displayskuGroups.length === 0) || false;
        });
         for (let i = 0; i < this.displayskuGroups?.length; i++) {
           skuIds.forEach((element) => {
           if(this.displayskuGroups[i].skuID === element){
            this.displayskuGroups.splice(i, 1)
           }
           });
         }
    }
    this.closeModal(this.deleteModalSkus);
    this.openModal(this.deleteAckModalSkus);
    this.skuDeleteEnable = false;
    this.resetSkuDelete();
  }
  findChecked(skuId) {
      return this.skusToDelete.includes(skuId)
  }
}
